import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const ModelSelectionTaxationWizard = lazy(() => import(/* webpackChunkName: "ModelSelectionTaxationWizard" */ './components/ModelSelectionTaxationWizard'));

const modelSelectionTaxationWizards = Array.from(document.querySelectorAll('#model-selection-taxation-wizard'));
if (modelSelectionTaxationWizards != null) {
    modelSelectionTaxationWizards.forEach(modelSelectionTaxationWizard => {
        const props = parseDatasetToProps(modelSelectionTaxationWizard.dataset);

        render(
            <Suspense fallback={<></>}>
                <ModelSelectionTaxationWizard
                    {...props}
                />
            </Suspense>,
            modelSelectionTaxationWizard
        );
    })
}
